/* Light/dark theme: applies the user's choice to <html data-theme> and notifies canvas widgets. */
import { Emitter } from './events';
import { getSettings, storeEvents } from './store/state';

export const themeEvents = new Emitter<{ change: string }>();

export function applyTheme(): void {
  const t = getSettings().theme;
  const root = document.documentElement;
  if (t === 'light' || t === 'dark') root.setAttribute('data-theme', t);
  else root.removeAttribute('data-theme');
  themeEvents.emit('change', t);
}

/** Applies the theme now and keeps it in sync with the setting and the OS preference. */
export function watchTheme(): () => void {
  applyTheme();
  const offSettings = storeEvents.on('settings', (e) => {
    if (e.key === 'theme') applyTheme();
  });
  const mq = window.matchMedia?.('(prefers-color-scheme: dark)');
  const onMq = () => themeEvents.emit('change', getSettings().theme);
  mq?.addEventListener?.('change', onMq);
  return () => {
    offSettings();
    mq?.removeEventListener?.('change', onMq);
  };
}
